import testService from './testService';

const parseDate = (d) => {
  if (!d) return new Date();
  try {
    if (typeof d === 'string') {
      const s = d.trim();
      // Treat ISO strings without timezone as UTC to avoid local-time skew (e.g., 8h difference in UTC+8)
      const hasTZ = /[zZ]|[+\-]\d{2}:\d{2}$/.test(s);
      const isISO = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}(:\d{2}(\.\d{1,7})?)?$/.test(s);
      if (isISO && !hasTZ) return new Date(s + 'Z');
    }
    return new Date(d);
  } catch {
    return new Date();
  }
};

// Server-backed notifications
const fetchNotifications = async ({ limit = 20 } = {}) => {
  const data = await testService.getNotifications();
  const items = data.Items || data.items || [];
  const mapped = items.map(it => ({
    id: it.Id ?? it.id,
    type: (it.Type ?? it.type ?? 'teacher_feedback').toLowerCase(),
    title: 'Teacher feedback available',
    message: `Feedback is ready for ${it.TestName ?? it.testName ?? 'your test'}`,
    testId: it.TestId ?? it.testId,
    approvedAt: parseDate(it.ApprovedAt ?? it.approvedAt),
    createdAt: parseDate(it.ApprovedAt ?? it.approvedAt),
    read: !!(it.ViewedAt ?? it.viewedAt),
    deleted: !!(it.DismissedAt ?? it.dismissedAt),
  }));
  // sort by approvedAt desc and apply limit client-side as a guard
  const sorted = mapped.sort((a, b) => b.approvedAt - a.approvedAt).slice(0, limit);
  return sorted;
};

const markAsRead = async (notifId) => {
  try { await testService.markNotificationRead(notifId); } catch {}
};

const deleteNotification = async (notifId) => {
  try { await testService.dismissNotification(notifId); } catch {}
};

const getUnreadCount = (notifications) => notifications.filter(n => !n.read).length;

export default {
  fetchNotifications,
  markAsRead,
  deleteNotification,
  getUnreadCount,
};
